/**
 * @module app.ext.cwqi
*/

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, Sorting, SortDirection } from 'app/shared/lib/essette-site';
import { IApiSettings } from 'app/shared/lib/api/api-types';
import { validate } from 'app/shared/elements/ess-rule';
import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { CwqiManager } from 'app/ext/cwqi/cwqi-manager';
import { I18N } from 'aurelia-i18n';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { localSort } from 'app/shared/lib/sorting';
import { deepClone } from 'app/shared/lib/utilities';
import * as MCG from 'app/mcg/models/essette-api';

export const requiredIncludes = [
    'Metadata_Modified_ByUser'
];

export const requiredFields = [
    'code',
    'indicationsStatus',
    'isIndicationsMet',
    'lengthOfStay',
    'metadata.modified.byUser.description',
    'metadata.modified.timestamp',
    'name',
    'product',
    'version'
];

@autoinject()
export class CwqiEpisodeGuidelineGridCustomElement extends ComponentBase {

    ////****************** Fields and Properties **************************************////
    @bindable.boolean()
    public readonly: boolean = true;

    @bindable.array({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload'})
    public guidelines: MCG.CwqiEpisodeGuideline[] = [];

    protected displayGuidelines: MCG.CwqiEpisodeGuideline[] = [];

    private sorting = new Sorting();

    @bindable.objectNull
    public apiSettings: IApiSettings | null = null;

    protected guidelineResultCount: number | null = 0;

    protected $isValid: boolean = true;
    protected validate = validate;

    private eventSubscriptions: Array<Subscription> = [];

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) ******************////
    constructor(
        private readonly events: EventAggregator,
        protected cwqi: CwqiManager,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected bind(bindingContext: Object, overrideContext: Object): void {
        this.reload();
    }

    protected unbind() {
        this.eventSubscriptions.forEach((s) => s.dispose());
        this.eventSubscriptions = [];
    }


    ////****************** Events ***************************************************////
    protected guidelinesChanged(): void {
        this.reload();
    }

    ////****************** Functions ************************************************////
    protected reload(): void {
        this.displayGuidelines = deepClone(this.guidelines);
        if(this.sorting.entries.length > 0) {
            localSort(this.displayGuidelines, this.sorting);
        }
    }

    protected applyGuidelineSort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
    }

    ////****************** Service Calls ********************************************////

}
